<template>
  <div v-if="$store.state.voterIdentification">
    <md-card class="custom">
      <div class="md-subtitle">
        <span class="md-caption">{{ $t("identity.subtitle") }}</span>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-25 label md-caption line">
          {{ $t("identity.personal-data.first-name") }}:
        </div>
        <div class="md-layout-item md-size-75 bold label line pl-30">
          {{
            $store.state.voterIdentification.Voter.VoterIdentifier.VoterName
              .PersonName.FirstName[0].value
          }}
        </div>

        <div
          class="md-layout-item md-size-25 label md-caption line"
          v-if="
            $store.state.voterIdentification.Voter.VoterIdentifier.VoterName
              .PersonName.MiddleName
          "
        >
          {{ $t("identity.personal-data.middle-name") }}
        </div>
        <div
          class="md-layout-item md-size-75 bold label line pl-30"
          v-if="
            $store.state.voterIdentification.Voter.VoterIdentifier.VoterName
              .PersonName.MiddleName
          "
        >
          {{
            $store.state.voterIdentification.Voter.VoterIdentifier.VoterName
              .PersonName.MiddleName[0].value
          }}
        </div>
        <div class="md-layout-item md-size-25 label md-caption line">
          {{ $t("identity.personal-data.last-name") }}:
        </div>
        <div class="md-layout-item md-size-75 bold label line  pl-30">
          {{
            $store.state.voterIdentification.Voter.VoterIdentifier.VoterName
              .PersonName.LastName[0].value
          }}
        </div>

        <div
          v-if="
            $store.state.voterIdentification.Voter.VoterInformation !== null &&
              $store.state.voterIdentification.Voter.VoterInformation
                .StringDateOfBirth
          "
          class="md-layout-item md-size-25 label md-caption line"
        >
          {{ $t("identity.personal-data.date-of-birth") }}:
        </div>
        <div
          v-if="
            $store.state.voterIdentification.Voter.VoterInformation !== null &&
              $store.state.voterIdentification.Voter.VoterInformation
                .StringDateOfBirth
          "
          class="md-layout-item md-size-75 bold label line pl-30"
        >
          {{
            $store.state.voterIdentification.Voter.VoterInformation
              .StringDateOfBirth
          }}
        </div>
        <div
          v-if="
            $store.state.voterIdentification.Voter.VoterInformation !== null &&
              $store.state.voterIdentification.Voter.VoterInformation
                .PlaceOfBirth
          "
          class="md-layout-item md-size-25 label md-caption line"
        >
          {{ $t("identity.personal-data.place-of-birth") }}:
        </div>
        <div
          v-if="
            $store.state.voterIdentification.Voter.VoterInformation !== null &&
              $store.state.voterIdentification.Voter.VoterInformation
                .PlaceOfBirth
          "
          class="md-layout-item md-size-75 bold label line pl-30"
        >
          {{
            $store.state.voterIdentification.Voter.VoterInformation.PlaceOfBirth
          }}
        </div>
      </div>
    </md-card>
    <profile
      v-if="
        $store.state.voterIdentification.Voter.VoterInformation !== null &&
          $store.state.voterIdentification.Voter.VoterInformation
            .FurtherInformation
      "
      class="label profile"
      :profile="
        $store.state.voterIdentification.Voter.VoterInformation
          .FurtherInformation
      "
    >
    </profile>

    <disclaimer class="custom" style="padding-left: 20px;"> </disclaimer>

    <session-already-open-dialog
      :confirmjustopen="confirmjustopen"
      @logout="logout()"
    >
    </session-already-open-dialog>
    <div v-if="$store.state.electionEvent" style="padding-top: 20px;">
      <md-button
        id="identityDeny"
        @click="clicked(false)"
        class="md-raised md-accent"
        :disabled="confirmDisabled"
        :aria-disabled="confirmDisabled"
        ><md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
          >Logout</md-tooltip
        >
        {{ $t("identity.deny-button") }}
      </md-button>
      <md-button
        id="login"
        @click="clicked(true)"
        class="md-raised md-primary"
        :disabled="confirmDisabled"
        :aria-disabled="confirmDisabled"
        ><md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
          >{{ $t("identity.go-to-vote-tooltip") }}</md-tooltip
        >
        <span v-if="!$store.state.electionEvent.ElectionEvent.Description">
          {{ $t("identity.confirm-button") }}
        </span>
        <span v-if="$store.state.electionEvent.ElectionEvent.Description">
          {{ $t("identity.accept-button") }}
        </span>
      </md-button>
    </div>
  </div>
</template>

<script>
import SessionAlreadyOpenDialog from "./SessionAlreadyOpenDialog";
import Disclaimer from "./Disclaimer";
import Profile from "./Profile";
import Utils from "../utils/Utils.js";

import { isMobile } from "mobile-device-detect";

export default {
  async mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
    document.getElementById("skip").focus();
    if (this.$store.state.voterIdentification.Voter.VoterIdentifier == null)
      this.$emit("identityNotRetrieved");
    this.$emit("identityRetrieved");
  },
  data: function() {
    return {
      confirmjustopen: false,
      isMobile: false,
      confirmDisabled: false
    };
  },
  props: [],
  methods: {
    async openSession() {
      let votingSession = await this.$store.state.ceoCbbService.openingVotingSession(
        this.$store.state.voterIdentification.EventIdentifier.Id,
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0]
      );

      if (votingSession.error) {
        //console.error(votingSession.error);
        if (votingSession.error.includes("CODE_JUST_OPEN_SESSION")) {
          this.confirmjustopen = true;
          return;
        }
        alert(votingSession.error + "\n\n" + this.$store.state.alertMessage);
        return;
      }
      if (votingSession.Accepted === "yes") {
        this.$emit("identityConfirmed");
      } else {
        this.logout();
      }
    },
    clicked(confirm) {
      this.confirmDisabled = true;
      if (confirm) {
        this.openSession();
      } else {
        if (this.$store.state.logoutUrl) {
          const url = this.$store.state.logoutUrl;
          this.$store.replaceState({});
          window.location.href = url;
        } else {
          this.$store.replaceState({});
          this.$keycloak.logoutFn();
        }
      }
    }
  },
  components: {
    Disclaimer,
    SessionAlreadyOpenDialog,
    Profile
  }
};
</script>

<style scoped>
.custom {
  margin: 5px 5px 0 5px;
  padding: 5px;
}

.label {
  text-align: left;
  margin: 0px;
  padding: 5px;
}

.md-card-content {
  padding: 30px !important;
  font-size: 18px;
  line-height: 22px;
}

.md-card {
  box-shadow: none !important;
  font-size: 18px !important;
  position: relative;
  z-index: 1;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: all;
  transition-property: color, background-color;
  will-change: color, background-color;
}

.md-card-header {
  text-align: left !important;
  text-transform: uppercase;
  border-left: 5px solid var(--pcolor);
  padding: 10px 20px;
  margin: 0 0 20px 5px;
}

.md-subtitle {
  text-align: left;
  text-transform: uppercase;
  font-size: 33px !important;
  border-left: 5px solid var(--pcolor);
  padding: 0 0 0 10px;
  margin: 20px 20px;
}

.custom .md-caption {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: 18px;
  color: #000;
}

.md-button.md-raised:not([disabled]) {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0),
    0 0 0 0 rgba(0, 0, 0, 0);
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor);
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: var(--pcolor) !important;
}

.md-button {
  padding: 0 30px !important;
  font-weight: bold;
  border-radius: var(--brb);
}

.line {
  border-bottom: 1px solid #dedede !important;
}

.label {
  padding: 10px 20px;
}

.profile {
  padding: 0;
}

@media screen and (max-width: 599px) {
  .md-button {
    padding: 0 15px !important;
  }
}
@media screen and (max-width: 360px) {
  .md-button {
    padding: 0 !important;
  }

  .pl-30 {
    padding-left: 30px;
  }
}
</style>
